import React from "react";

import { Weight as WeightClass, WeightUnits, WeightUnit } from "shared/utils";

interface WeightProps {
  weight: number;
  toUnit?: WeightUnit;
}

export const Weight: React.FC<WeightProps> = ({ weight, toUnit = WeightUnits.kg }) => {
  return <>{new WeightClass(weight, WeightUnits.g).convert(toUnit).toString()}</>;
};
